import React from 'react';
import { cn } from '../../../lib/utils';

interface SegmentedOption {
  id: string;
  label: string;
}

interface SegmentedProps {
  options: SegmentedOption[];
  value: string;
  onChange: (v: string) => void;
}

export function Segmented({ options, value, onChange }: SegmentedProps): React.ReactElement {
  return (
    <div className="flex bg-[#F1F5F9] border border-[#CBD5E1] p-1 rounded-lg">
      {options.map((o) => {
        const active = o.id === value;
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => onChange(o.id)}
            className={cn(
              'flex-1 py-2 px-2 text-[13px] font-medium rounded-md transition-colors',
              active ? 'bg-white text-ink shadow-sm border border-ink' : 'text-[#334155] hover:text-ink'
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
